var Xmodal = (function($) {
  var _this = {};

  _this.initialize = function() {
    bind();
  }



  _this.open = function(a) {
    // insert content
    $('.xmodal-content').html(a);
    $('body').addClass('xmodal-open');
  }
  _this.close = function() {
    $('body').removeClass('xmodal-open');
  }

  return _this;

  function bind() {
    $(document).on('click', '.close-xmodal', function(event) {
      event.preventDefault();
      _this.close();
    });
    $(document).on('click', '.xmodal-overlay', function(event) {
      event.preventDefault();
      _this.close();
    });
  }

}(jQuery));

$(document).ready(function() {

  Xmodal.initialize();

});